class RGB {
  rgb: number[] | null;

  constructor(hex: string) {
    this.rgb = this.setRGB(hex);
  }

  setRGB(hex: string) {
    if (!hex) return null;

    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    const newhex = hex.replace(
      shorthandRegex,
      (_m: string, r: string, g: string, b: string) => {
        return r + r + g + g + b + b;
      }
    );

    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(newhex);
    return result
      ? [
          parseInt(result[1], 16),
          parseInt(result[2], 16),
          parseInt(result[3], 16)
        ]
      : null;
  }

  toString(opacity?: number) {
    const op = !opacity || opacity < 0 || opacity > 1 ? 1 : opacity;

    return this.rgb
      ? `rgba(${this.rgb[0]}, ${this.rgb[1]}, ${this.rgb[2]}, ${op})`
      : null;
  }
}

export default RGB;
